module.exports = __webpack_public_path__ + "static/media/Alesund_Norway_1.5ddf2052.jpg";